import { defineMessages } from 'react-intl'

const scope = `procurify.discoverMore.showWhatsNewPromo.WhatsNewPromoCard`

export default defineMessages({
  ctaButton: {
    id: `${scope}.ctaButton`,
    defaultMessage: `Learn more about what’s new`,
  },
  releaseDotLabel: {
    id: `${scope}.releaseDotLabel`,
    defaultMessage: 'Show update {position} of {total}',
  },
  loadingLabel: {
    id: `${scope}.loadingLabel`,
    defaultMessage: 'Loading the latest updates',
  },
  apPromotionBadge: {
    id: `${scope}.apPromotionBadge`,
    defaultMessage: 'Add-on',
  },
  apPromotionTitle: {
    id: `${scope}.apPromotionTitle`,
    defaultMessage: 'Complete your Procure-to-Pay workflow',
  },
  apPromotionDescription: {
    id: `${scope}.apPromotionDescription`,
    defaultMessage:
      'Add Accounts Payable to automate every step from PO to payment. Learn how AI matches invoices, pre-fills bill data, and speeds up invoice processing.',
  },
  apPromotionImageAlt: {
    id: `${scope}.apPromotionImageAlt`,
    defaultMessage: 'Procurify Accounts Payable',
  },
  apPromotionCtaButton: {
    id: `${scope}.apPromotionCtaButton`,
    defaultMessage: 'Learn more',
  },
  pulsePromotionTitle: {
    id: `${scope}.pulsePromotionTitle`,
    defaultMessage: "Get a front-row seat for what's next at Pulse 2026!",
  },
  pulsePromotionDescription: {
    id: `${scope}.pulsePromotionDescription`,
    defaultMessage:
      "Be the first to see what's coming to Procurify, explore what's possible with agentic AI, and learn from other customers. Plus, join exclusive workshops dedicated to our customer community.",
  },
  pulsePromotionCtaButton: {
    id: `${scope}.pulsePromotionCtaButton`,
    defaultMessage: 'Save my seat',
  },
  pulsePromotionImageAlt: {
    id: `${scope}.pulsePromotionImageAlt`,
    defaultMessage: 'Pulse virtual summit: The Agentic Frontier in Procurement',
  },
})
